export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const googleAnalyticsConfig = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
